import script from "./reworkDetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./reworkDetails.vue?vue&type=script&setup=true&lang=ts"

import "./reworkDetails.vue?vue&type=style&index=0&id=30373e8e&lang=scss&scoped=true"

import exportComponent from "D:\\code\\idea2023\\dmMes\\h5_standard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30373e8e"]])

export default __exports__